import React from "react";

export default function SlotMachineIcon({ className = "" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
        >
            <path d="M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm2 4v10h10V7H7zm2 2h2v6H9V9zm4 0h2v6h-2V9z" />
        </svg>
    );
}
